import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { campsenum } from '../models/enums.generated';


@Injectable()
export class CampsEnumTranslationService {
    constructor(private translate: TranslateService) { }

    public timeVariant(variant: campsenum.TimeRangeVariantType): string {
        const key = 'TimeRangeVariantType.' + campsenum.TimeRangeVariantType[variant];
        return this.translate.instant(key);
    }

    public paymentMethod(variant: campsenum.PaymentMethod): string {
        const key = 'PaymentMethod.' + campsenum.PaymentMethod[variant];
        return this.translate.instant(key);
    }

    public purchaseStatus(variant: campsenum.CampPurchaseStatus): string {
        const key = 'CampPurchaseStatus.' + campsenum.CampPurchaseStatus[variant];
        return this.translate.instant(key);
    }

    public campStatus(variant: campsenum.CampStatus): string {
        const key = 'CampStatus.' + campsenum.CampStatus[variant];
        return this.translate.instant(key);
    }

    public campCareDayStatus(status: campsenum.CampCareDayStatus): string {
        const key = 'CampCareDayStatus.' + campsenum.CampCareDayStatus[status];
        return this.translate.instant(key);
    }

    public discountType(type: campsenum.DiscountType): string {
        const key = 'DiscountType.' + campsenum.DiscountType[type];
        return this.translate.instant(key);
    }
    
    public membershipTier(type: campsenum.MembershipTier): string {
        const key = 'MembershipTier.' + campsenum.MembershipTier[type];
        return this.translate.instant(key);
    }

    public optionType(type: campsenum.OptionType): string {
        const key = 'OptionType.' + campsenum.OptionType[type];
        return this.translate.instant(key);
    }

    
    public couponType(type: campsenum.CouponType): string {
        const key = 'CouponType.' + campsenum.CouponType[type];
        return this.translate.instant(key);
    }

    public couponStatus(type: campsenum.CouponStatus): string {
        const key = 'CouponStatus.' + campsenum.CouponStatus[type];
        return this.translate.instant(key);
    }

    public couponAction(type: campsenum.CouponActionType): string {
        const key = 'CouponActionType.' + campsenum.CouponActionType[type];
        return this.translate.instant(key);
    }

    public campType(type: campsenum.CampType): string {
        const key = 'CampType.' + campsenum.CampType[type];
        return this.translate.instant(key);
    }

    public reservationDaysAheadLimitVariant(variant: campsenum.ReservationDaysAheadLimitVariant): string {
        const key = 'ReservationDaysAheadLimitVariant.' + campsenum.ReservationDaysAheadLimitVariant[variant];
        return this.translate.instant(key);
    }

    public couponUsageType(type: campsenum.CouponUsageType): string {
        const key = 'CouponUsageType.' + campsenum.CouponUsageType[type];
        return this.translate.instant(key);
    }

    public refundReason(variant: campsenum.RefundReason): string {
        const key = 'RefundReason.' + campsenum.RefundReason[variant];
        return this.translate.instant(key);
    }
}
